import React, { useEffect, useState } from "react";
import PopModal from "../../../Constant/Custom/Models/PopModal";
import prevIcon from "../../../Constant/Icons/leftarrow.svg";
import nextIcon from "../../../Constant/Icons/rightarrow.svg";
import saveIcon from "../../../Constant/Icons/save.svg";
import deleteIcon from "../../../Constant/Icons/delete.svg";
import { serverUrl } from "../../../Constant/Static/config";
import axios from "axios";

function CVstaffs() {
  // const [modelloading, setModelLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ title: "", text: "", icon: "" });
  const [onConfirm, setOnConfirm] = useState(() => () => { });
  const [showCancelButton, setShowCancelButton] = useState(false);
  const [onCancel, setOnCancel] = useState(() => () => { });
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(
          `${serverUrl}/api/admin/cv/records?page=${page}&pageSize=${pageSize}`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const result = await response.json();
          // console.log("result", result);
          setData(result.data);
          setData((prevData) =>
            prevData.map((row) => {
              const update = result.details.find(
                (update) => update.verifier_id === row.verifier_id
              );
              return update
                ? {
                  ...row,
                  from: update.FROM,
                  to: update.TO,
                  table: update.TABLE_NAME,
                }
                : { ...row, from: "", to: "", table: "" };
            })
          );
          // console.log("data", data);

          setTotalPages(result.totalPages);
        } else {
          throw new Error("Received non-JSON response");
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    if (pageSize > 0) {
      fetchData();
    }
  }, [page, pageSize]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  const handleChange = (user_id, e) => {
    // console.log("event", e);

    const { name, value } = e.target;
    setData((prevData) =>
      prevData.map((row) =>
        row.verifier_id === user_id ? { ...row, [name]: value } : row
      )
    );
  };

  const handleLogAccessChange = async (userId, newValue) => {
    // console.log("newvalue", newValue);

    try {
      const response = await fetch(
        `${serverUrl}/api/admin/cv/update-log-access`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ userId, logAccess: newValue }),
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();
      if (result.success) {
        // console.log("success");
        setModalType({
          title: "Success",
          icon: "success",
          text: "Updated Successfully",
        });
        setShowCancelButton(false);
        // setOnCancel(() => closeModal);
        setOnConfirm(() => closeModal);
        openModal();
        setData((prevData) =>
          prevData.map((row) =>
            row.verifier_id === userId ? { ...row, LOG_ACCESS: newValue } : row
          )
        );

        // console.log(data);
      } else {
        throw new Error("Failed to update log access");
      }
    } catch (error) {
      setModalType({
        title: "Error",
        icon: "error",
        text: "Failed To Update",
      });
      setShowCancelButton(false);
      // setOnCancel(() => closeModal);
      setOnConfirm(() => closeModal);
      openModal();
      setError(error.message);
    }
  };
  const denyAllStaff = async () => {
    try {
      const response = await axios.post(`${serverUrl}/api/admin/cv/denyallstaff`, {}
      )
      if (response.status === 200) {
        setModalType({
          title: "Success",
          icon: "success",
          text: "Updated Successfully",
        });
        setShowCancelButton(false);

        openModal();
        setOnConfirm(() => () => window.location.reload());

      }

    }
    catch (err) {
      setModalType({
        title: "Error",
        icon: "error",
        text: "Failed To Update",
      });
      setShowCancelButton(false);
      // setOnCancel(() => closeModal);
      setOnConfirm(() => closeModal);
      openModal();


    }

  }
  const handleRangeChange = async (data) => {
    const dataToSend = {
      USER_ID: data.verifier_id,
      from: data.from,
      to: data.to,
      table: data.table,
      NAME: data.verifier_name,
      MOBILE: data.MOBILE
      
    };
    // console.log("dataToSend", dataToSend);
    try {
      const response = await axios.post(
        `${serverUrl}/api/admin/cv/rangeChange`,
        { data: dataToSend }
      );
      if (response.status === 200) {
        setModalType({
          title: "Success",
          icon: "success",
          text: "Updated Successfully",
        });
        setShowCancelButton(false);
        // setOnCancel(() => closeModal);
        setOnConfirm(() => closeModal);
        openModal();
      }
      // console.log("response", response);
    } catch (err) {
      setModalType({
        title: "Error",
        icon: "error",
        text: "Failed To Update",
      });
      setShowCancelButton(false);
      // setOnCancel(() => closeModal);
      setOnConfirm(() => closeModal);
      openModal();
      // // console.log("error range:", err);
    }
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const result = await axios.get(
  //         `${serverUrl}/api/admin/cv/fetchData`,
  //         {}
  //       );
  //     } catch (err) {
  //       // console.log("error", err);
  //     }
  //   };

  //   fetchData();
  // }, []);

  return (
    <div className="student-table-wrapper">
      <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}  >
        <button style={{ color: "white", backgroundColor: "#007bff", borderRadius: "5px", height: "30px", border: "none" }} onClick={denyAllStaff} >DENY ALL</button>
      </div>

      <div className="student-table-container">
        {error && <div>Error: {error}</div>}
        <table className="student-responsive-table">
          <thead>
            <tr>
              <th>S No.</th>
              <th>User ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>From</th>
              <th>To</th>
              <th>Table Name</th>
              <th>Log Access</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{row.verifier_id}</td>
                <td>{row.verifier_name}</td>
                <td>{row.EMAIL}</td>
                <td>{row.MOBILE}</td>
                <td>
                  <input

                    type="tel"
                    id="from"
                    name="from"
                    onChange={(e) => handleChange(row.verifier_id, e)}
                    value={row.from}
                    placeholder="Enter Value"
                  />
                </td>
                <td>
                  <input
                    type="tel"
                    id="to"
                    name="to"
                    onChange={(e) => handleChange(row.verifier_id, e)}
                    value={row.to}
                    placeholder="Enter Value"
                  />
                </td>
                <td>
                  <select
                    name="table"
                    // value={row.table}
                    onChange={(e) => handleChange(row.verifier_id, e)}
                  >
                    <option value="">--- Select ---</option>
                    {/* <option
                      value="lat_stu_others"
                      selected={row.table === "lat_stu_others"}
                    >
                      lat_stu_others
                    </option> */}
                    {/* <option value="lat_stu_dip_2025" {row.TABLE_NAME === "lat_stu_dip_2025" && selected}>lat_stu_dip_2025</option> */}
                    <option
                      value="lat_stu_dip"
                      selected={row.table === "lat_stu_dip"}
                    >
                      lat_stu_dip
                    </option>
                    <option
                      value="lat_stu_bsc"
                      selected={row.table === "lat_stu_spl"}
                    >
                      lat_stu_spl
                    </option>
                    <option
                      value="lat_stu_bsc"
                      selected={row.table === "lat_stu_bsc"}
                    >
                      lat_stu_bsc
                    </option>
                    <option
                      value="lat_stu_dip_2"
                      selected={row.table === "lat_stu_dip_2"}
                    >
                      lat_stu_dip_2
                    </option>
                    <option
                      value="lat_stu_bsc_2"
                      selected={row.table === "lat_stu_spl_2"}
                    >
                      lat_stu_spl_2
                    </option>
                    <option
                      value="lat_stu_bsc_2"
                      selected={row.table === "lat_stu_bsc_2"}
                    >
                      lat_stu_bsc_2
                    </option>
                  </select>
                </td>
                <td>
                  <select
                    name="LOG_ACCESS"
                    value={row.LOG_ACCESS}
                    onChange={(e) => handleChange(row.verifier_id, e)}
                  >
                    <option value="Y">Allow</option>
                    <option value="N">Deny</option>
                  </select>
                </td>
                <td
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    flexDirection: "row",
                  }}
                >
                  <button
                    onClick={() =>
                      handleLogAccessChange(row.verifier_id, row.LOG_ACCESS)
                    }
                  >
                    Update Access
                    {/* <img src={saveIcon} width={20} height={20} alt="Save" /> */}
                  </button>{" "}
                  &ensp;
                  <button onClick={() => handleRangeChange(row)}>
                    Update Range
                    {/* <img src={deleteIcon} width={20} height={20} alt="Save" /> */}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {loading && <div>Loading...</div>}
      </div>
      <div className="pagination">
        <button
          onClick={() => handlePageChange(page - 1)}
          disabled={page === 1 || loading}
        >
          <img src={prevIcon} width={15} height={15} alt="Back" />
        </button>
        <span>
          {page} of {totalPages}
        </span>
        <button
          onClick={() => handlePageChange(page + 1)}
          disabled={page === totalPages || loading}
        >
          <img src={nextIcon} width={15} height={15} alt="Next" />
        </button>
      </div>
      <div
        style={{
          position: "relative",
          alignSelf: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <PopModal
          isOpen={isModalOpen}
          type={modalType}
          confirmButtonText="OK"
          showCancelButton={showCancelButton}
          cancelButtonText="Cancel"
          onConfirm={onConfirm}
          onCancel={onCancel}
        />
      </div>
    </div>
  );
}

export default CVstaffs;
